var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFabricacionMovil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 223.993,
    height: 38,
    viewBox: "0 0 223.993 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Uni\\xF3n_10",
    x: 0,
    y: 0,
    width: 223.993,
    height: 38,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "boton_fabricacion",
    "data-name": "boton fabricacion",
    transform: "translate(-26.507 -321.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 26.51, 321.5)",
    filter: "url(#Uni\\xF3n_10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_10-2",
    "data-name": "Uni\\xF3n 10",
    d: "M-858.487-1931h-1.006a14.5,14.5,0,0,1-14.5-14.5,14.5,14.5,0,0,1,14.5-14.5H-673.5a14.5,14.5,0,0,1,14.5,14.5,14.5,14.5,0,0,1-14.5,14.5Z",
    transform: "translate(878.49 1962.5)",
    fill: "#9b2690"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_171380",
    "data-name": "Trazado 171380",
    d: "M23.476,8.772H21.988V7.08H20.524V8.772H17.776l3.9-5.172H20.008l-4.14,5.412v1.08h4.608V12h1.512V10.092h1.488Zm10.7-3.864V3.6H28.048V12h1.56V8.784h4.056V7.464H29.608V4.908Zm3.612.612a4.506,4.506,0,0,0-2.712.792L35.668,7.4a3.172,3.172,0,0,1,1.944-.636c1.068,0,1.6.516,1.6,1.392v.1H37.552c-1.944,0-2.664.84-2.664,1.908,0,1.116.924,1.92,2.388,1.92a2.271,2.271,0,0,0,2.016-.864V12h1.416V8.244C40.708,6.4,39.64,5.52,37.792,5.52Zm-.2,5.472c-.768,0-1.224-.348-1.224-.888,0-.468.276-.852,1.3-.852h1.548V10A1.633,1.633,0,0,1,37.588,10.992ZM46.18,5.52a2.664,2.664,0,0,0-2.052.852V3.1h-1.5V12h1.428v-.828a2.642,2.642,0,0,0,2.124.912A3.121,3.121,0,0,0,49.432,8.8,3.112,3.112,0,0,0,46.18,5.52Zm-.168,5.28a1.873,1.873,0,0,1-1.908-2,1.9,1.9,0,1,1,3.8,0A1.864,1.864,0,0,1,46.012,10.8Zm6.276-4.272V5.592H50.86V12h1.5V8.892a1.747,1.747,0,0,1,1.86-1.98,1.9,1.9,0,0,1,.348.036V5.52A2.522,2.522,0,0,0,52.288,6.528ZM56.6,4.536a.921.921,0,0,0,.96-.936.893.893,0,0,0-.96-.864.9.9,0,1,0,0,1.8ZM55.84,12h1.5V5.592h-1.5Zm6.408.084a2.913,2.913,0,0,0,2.736-1.5l-1.152-.672a1.813,1.813,0,0,1-1.6.888,1.874,1.874,0,0,1-1.944-2,1.881,1.881,0,0,1,1.944-2,1.813,1.813,0,0,1,1.6.888l1.152-.672A2.884,2.884,0,0,0,62.248,5.52a3.287,3.287,0,1,0,0,6.564Zm6.48-6.564a4.506,4.506,0,0,0-2.712.792L66.6,7.4a3.172,3.172,0,0,1,1.944-.636c1.068,0,1.6.516,1.6,1.392v.1H68.488c-1.944,0-2.664.84-2.664,1.908,0,1.116.924,1.92,2.388,1.92a2.271,2.271,0,0,0,2.016-.864V12h1.416V8.244C71.644,6.4,70.576,5.52,68.728,5.52Zm-.2,5.472c-.768,0-1.224-.348-1.224-.888,0-.468.276-.852,1.3-.852h1.548V10A1.633,1.633,0,0,1,68.524,10.992Zm8.04,1.092a2.913,2.913,0,0,0,2.736-1.5l-1.152-.672a1.813,1.813,0,0,1-1.6.888,1.874,1.874,0,0,1-1.944-2,1.881,1.881,0,0,1,1.944-2,1.813,1.813,0,0,1,1.6.888L79.3,7.008A2.884,2.884,0,0,0,76.564,5.52a3.287,3.287,0,1,0,0,6.564Zm4.788-7.548a.921.921,0,0,0,.96-.936.893.893,0,0,0-.96-.864.9.9,0,1,0,0,1.8ZM80.6,12h1.5V5.592H80.6Zm5.328-7.284h1.3l2.088-1.644H87.544Zm1.02,7.368A3.232,3.232,0,0,0,90.364,8.8a3.417,3.417,0,0,0-6.828,0A3.235,3.235,0,0,0,86.944,12.084Zm0-1.284a1.864,1.864,0,0,1-1.9-2,1.9,1.9,0,1,1,3.8,0A1.866,1.866,0,0,1,86.944,10.8Zm8.5-5.28a2.786,2.786,0,0,0-2.208.9V5.592H91.8V12h1.5V8.76a1.7,1.7,0,0,1,1.788-1.932c.96,0,1.524.552,1.524,1.692V12h1.5V8.328A2.5,2.5,0,0,0,95.44,5.52Z",
    transform: "translate(81.5 331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22016",
    "data-name": "Grupo 22016",
    transform: "translate(37.547 328.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_171075",
    "data-name": "Trazado 171075",
    d: "M18.46,7.965h-.91a7.75,7.75,0,0,0-.838-2.029l.641-.642a.655.655,0,0,0,0-.927L15.5,2.512a.655.655,0,0,0-.927,0l-.642.641A7.761,7.761,0,0,0,11.9,2.315v-.91A.655.655,0,0,0,11.245.75H8.621a.655.655,0,0,0-.656.656v.91a7.761,7.761,0,0,0-2.028.838l-.642-.641a.655.655,0,0,0-.927,0L2.512,4.367a.655.655,0,0,0,0,.927l.641.642a7.759,7.759,0,0,0-.838,2.029h-.91a.656.656,0,0,0-.656.656v2.624a.656.656,0,0,0,.656.656h.91a7.757,7.757,0,0,0,.838,2.028l-.641.642a.656.656,0,0,0,0,.928l1.855,1.855a.655.655,0,0,0,.927,0l.642-.641a7.761,7.761,0,0,0,2.028.838v.91a.656.656,0,0,0,.656.656h2.624a.656.656,0,0,0,.656-.656v-.91a7.761,7.761,0,0,0,2.028-.838l.642.641a.655.655,0,0,0,.927,0L17.353,15.5a.656.656,0,0,0,0-.928l-.641-.642A7.749,7.749,0,0,0,17.55,11.9h.91a.655.655,0,0,0,.656-.656V8.621a.655.655,0,0,0-.656-.656m-4.591,3.279a1.3,1.3,0,0,1-.724,1.173L9.933,14.131,6.707,12.41A1.3,1.3,0,0,1,6,11.244V7.53a.656.656,0,0,1,.367-.589L9.346,5.48a1.313,1.313,0,0,1,1.174,0L13.5,6.953a.656.656,0,0,1,.366.588Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_171077",
    "data-name": "Trazado 171077",
    d: "M32.649,24.124l-2.624-1.312a.656.656,0,0,0-.587,0l-2.624,1.312a.686.686,0,0,0-.062.042l2.979,1.489,2.979-1.489a.725.725,0,0,0-.062-.042",
    transform: "translate(-19.799 -16.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_171079",
    "data-name": "Trazado 171079",
    d: "M25.492,34.393a.656.656,0,0,0,.363.587l2.589,1.381V32.628l-2.952-1.476Z",
    transform: "translate(-18.839 -23.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_171081",
    "data-name": "Trazado 171081",
    d: "M40.612,36.36,43.2,34.979a.656.656,0,0,0,.363-.587V31.152l-2.952,1.476Z",
    transform: "translate(-30.351 -23.148)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabricacionMovil);
export default __webpack_public_path__ + "static/media/fabricacionMovil.b0188e4096329635ebace2267ddd7e47.svg";
export { ForwardRef as ReactComponent };